import { isNil } from 'lodash';

export const doesNotExistValue = value => isNil(value) || value === '';

// Checks for strict false only (not falsy values)
export const isFalseStrict = value => typeof value === 'boolean' && value === false;

export default doesNotExistValue;
